export enum EnvironmentType {
  node = 'node',
  browser = 'browser',
}
